import React, { useEffect, useState } from "react";
import useGlobal from "../../store";
import { addBuildingNote, buildingById, getBuildingNotes, getBuildingZones, updateBuilding } from "../../services/MetadataService";
import FileList from "../../components/FileList";
import { getEntityDocuments } from "../../services/FileService";

import LoadedEquipmentList from "../../loaded/LoadedEquipmentList";
import ZoneList from "../../components/ZoneList";
import LoadedSpaceList from "../../loaded/LoadedSpaceList";
import FloorMapView from "../../components/FloorMapView"
import ScheduleView from "../../components/Schedule"

import { IconButton } from "@material-ui/core";
import { ModeEdit,  Settings } from "@mui/icons-material";
import { Error } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { TextField, Autocomplete } from "@mui/material";
import {Auth} from "aws-amplify";
import Notes from "../../components/Notes";


const ShowBuilding = (props) => {
    const [building, setBuilding] = useState()
    const [zones, setZones] = useState()
    const [files, setFiles] = useState()
    const [notes, setNotes] = useState();
    let [currentUser, setCurrentUser] = useState()

    let [currentState, currentActions] = useGlobal();
    let[editMode, setEditMode] = useState(false);
    let[error, setError] = useState();
    let history = useHistory();

    useEffect(() => {
        let buildingId = props && props.buildingId
        if (!building) {
            buildingById(buildingId).then(response => {
                setBuilding(response)
            });
        }

        if (!currentUser) {
            Auth.currentUserInfo().then(response => {
                setCurrentUser(response.attributes.name)
            })
        }

        getZones(buildingId)

        getBuildingNotes(buildingId).then(response => {
			setNotes(response)
		})

		getFiles(buildingId)
    }, [])

    const getFiles = (building_id) => {
        let buildingId = building_id || building.id
        getEntityDocuments("buildings", buildingId).then(setFiles)
    }

    const getZones = (buildingId) => {
        getBuildingZones(buildingId).then(response => {
            setZones(response)
        });
    }

	const setName = (value) => {
		let currentBuilding = Object.assign({}, building);
		currentBuilding.name = value;
		setBuilding(currentBuilding);
	};

    const setArea = (value) => {
		let currentBuilding = Object.assign({}, building);
		currentBuilding.area = value

		if (currentBuilding.volume) currentBuilding.volume = value * currentBuilding.floor_to_ceiling_height
		setBuilding(currentBuilding)
	}

	const setHeight = (value) => {
		let currentBuilding = Object.assign({}, building);
		currentBuilding.floor_to_ceiling_height = value

		if (currentBuilding.area) currentBuilding.volume = value * currentBuilding.area
		setBuilding(currentBuilding)
	}

	const submitChanges = () => {
        console.log(building)
		updateBuilding(building).then(response => {
			setBuilding(response)
			setEditMode(false)
		}).catch(error => {
			console.log(error)
			setError("There was an error updating the building.")
		});
	}

    const addNote = async (note) => {
		note.author = currentUser;
		addBuildingNote(building.id, note).then(() => {
			getBuildingNotes(building.id).then(response => {
				setNotes(response)
			})
		}).catch(err => {
			console.log(err)
		})

	}

	useEffect(() => {
        if (building) {
            currentActions.setBuilding(building)
        }
    },[building]) //We should probably do the same with spaces and equipment but for now will call separately

    return <div className="layer3">
            <div className="location">
                {  building ?
                    <div className="space-stats">
                        <div className="section-header">Stats
                            <div className="edit-element">
                                <IconButton
                                            variant="contained"
                                            color="primary"
                                            aria-label={"Edit these values" }

                                            onClick={() => {
                                                setEditMode(true)
                                        }}>
                                        <ModeEdit style={{fill: "#00b088", background: "white", transform: "scale(0.8)"}}/>
                                </IconButton>
                                <IconButton
                                            variant="contained"
                                            color="primary"
                                            aria-label={"View and edit building configuration" }

                                            onClick={() => {
                                                history.push("/variables/building/" + building.id)
                                        }}>
                                            <Settings style={{fill: "#003e51", background: "white", transform: "scale(0.8)"}}/>
                                </IconButton>
                            </div>
                        </div>
                        <div className="stats-container">
                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField label="Building Name" defaultValue={building.name} variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}}/>
                            </div>
                            :
                            null
                        }

                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField type="number" label="Area" defaultValue={building.area} variant="outlined" size="small" onChange={(e) => {setArea(e.target.value)}}/>
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">Area</div>
                                { building.area ?
                                    <div className="stat-value">{building.area} sqft</div> :
                                    <div className="stat-unavailable">Add default Value</div>
                                }
                            </div>
                        }

                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField type="number" label="Floor to Ceiling Height" defaultValue={building.floor_to_ceiling_height} variant="outlined" size="small" onChange={(e) => {setHeight(e.target.value)}}/>
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">Floor to Ceiling Height</div>
                                {building.floor_to_ceiling_height ?
                                    <div className="stat-value">{building.floor_to_ceiling_height} ft</div> :
                                    <div className="stat-unavailable">Add default Value</div> }
                            </div>
                        }

                        { editMode ?
                            <div className="stat-edit">
                                <Autocomplete
                                    disablePortal
                                    id="ownership"
                                    options={["Owned","Leased"]}
                                    defaultValue={building.ownership_status}
                                    renderInput={(params) => <TextField {...params} label="Ownership" variant="outlined" fullWidth size="small" />}
                                    style={{ width: "200px" }}
                                    size="small"
                                    onChange={(event, newValue) => {
                                        let currentBuilding = Object.assign({}, building);
                                        currentBuilding.ownership_status = newValue
                                        setBuilding(currentBuilding)
                                    }}
                                />
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">Ownership</div>
                                {building.ownership_status ?
                                    <div className="stat-value">{building.ownership_status}</div> :
                                    <div className="stat-unavailable">Add value</div> }
                            </div>
                        }

                        {
                            editMode ?
                            <div className="stat">
                                <div className="stat-edit-button" onClick={submitChanges}>Submit</div>
                            </div>
                            :
                            null
                        }
                        </div>
                    </div>
                : null }
                { building && <ZoneList zones={zones} siteId={building.site_id} buildingId={props.buildingId} /> }
                { building && <LoadedSpaceList siteId={building.site_id} buildingId={props.buildingId} /> }
                { building && <LoadedEquipmentList siteId={building.site_id} buildingId={props.buildingId} /> }
				<Notes notes={notes} onSubmit={addNote} />
                <FileList files={files} context="building" id={props.buildingId} filesAccessor={getFiles} />
            </div>
    	</div>
}

export default ShowBuilding;